export default "__VITE_ASSET__Dom6doCD__"